import { useAction } from 'hooks'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { setDndDropTarget } from 'actions/mainView'
import { selectActiveDragElement } from 'selectors/mainView'
import { DROP_TARGET_TYPE } from 'enums'

export const useActivateMediaDropAreaOnSourceAssets = (
  sourceAssetRef: React.MutableRefObject<null | HTMLDivElement>
) => {
  const activeMainViewDragElement = useSelector(selectActiveDragElement)
  const dndDropTarget = useSelector((state: RootState) => state.mainView.dndDropTarget)
  const onSetDndDropTarget = useAction(setDndDropTarget)
  useEffect(() => {
    const sourceAsset = sourceAssetRef.current
    let isDrag = false

    const dragover = () => {
      if (!activeMainViewDragElement && !isDrag) {
        onSetDndDropTarget(DROP_TARGET_TYPE.SOURCE_MEDIA)
      }
    }

    const dragleave = () => {
      if (!activeMainViewDragElement
        && !isDrag
        && dndDropTarget !== DROP_TARGET_TYPE.ROOT
      ) {
        onSetDndDropTarget(DROP_TARGET_TYPE.ROOT)
      }
    }
    const drag = () => { isDrag = true }
    const drop = () => { isDrag = false }

    if (sourceAsset) {
      sourceAsset.addEventListener('dragover', dragover)
      sourceAsset.addEventListener('dragleave', dragleave)
      sourceAsset.addEventListener('drag', drag)
      sourceAsset.addEventListener('drop', drop)
      window.addEventListener('mouseup', dragleave)
    }
    return () => {
      if (sourceAsset) {
        sourceAsset.removeEventListener('dragover', dragover)
        sourceAsset.removeEventListener('dragleave', dragleave)
        sourceAsset.removeEventListener('drag', drag)
        sourceAsset.removeEventListener('drop', drop)
        window.removeEventListener('mouseup', dragleave)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ activeMainViewDragElement, dndDropTarget ])
}
